













































import Vue from 'vue';
import api from '../../../api';

export default Vue.extend({
  name: 'ReviewForm',

  data: () => ({
    title: '',
    description: '',
    rating: 0,
  }),

  props: {
    showId: {
      type: Number,
      required: true,
    },
  },

  methods: {
    changeRating(index: number) {
      this.rating = index;
    },

    async execute() {
      await api.review.create(
        this.showId,
        this.title,
        this.rating,
        this.description,
      );

      this.$emit('created');
    },
  },

  computed: {
    valid() {
      return this.title.length !== 0;
    },
  },
});
